import React from 'react';

// bootstrap
import Spinner from 'react-bootstrap/Spinner'
import Row from 'react-bootstrap/Row'


const CustomSpinner = (props) => {

    // centered spinner in row with margin
    if (props.rowCenter) {
        return (
            <Row className='mt-5' style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                <div style={props.style}>
                    <Spinner
                        animation="border"
                        size={'sm'}
                        role="status"
                        aria-hidden="true"
                        variant="primary"
                    //style={props.style}
                    />
                </div>
            </Row>
        )
    }

    // just spinner logo
    return (
        <Spinner
            as="span"
            animation="border"
            size={props.size && props.size == 'small' ? "sm" : "xs"}
            role="status"
            aria-hidden="true"
            variant={props.variant ? props.variant : "primary"}
        />

    );
};

export default CustomSpinner;